import React, { useEffect } from 'react';

import {
  useLoginFormState,
  useLoginFormActions
} from './LoginFormContext';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';
import CenterFill from '../../Shared/UI/CenterFill/components/CenterFill';

import { createSession } from '../../Account/components/restApi';

const LoginForm = ({ handleCloseWizard, nextStep }) => {
  const state = useLoginFormState();
  const {
    initializeState,
    updateEmail,
    updatePassword,
    onResponse,
    onError,
  } = useLoginFormActions();

  useEffect(() => {
    initializeState();
  }, []);

  const handleSubmit = () => {
    createSession({
      onResponse,
      onError,
      body: {
        email: state?.loginForm?.email || '',
        password: state?.loginForm?.password || '',
        authenticityToken: document.querySelector("meta[name='csrf-token']").getAttribute("content")
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Email" id="email">
        <Input
          type="email"
          name="session[email]"
          value={state?.loginForm?.email || ''}
          onChange={(e) => updateEmail(e.target.value)}
        />
      </Field>

      <Field label="Password" id="password">
        <Input
          type="password"
          name="session[password]"
          value={state?.loginForm?.password || ''}
          onChange={(e) => updatePassword(e.target.value)}
        />
      </Field>

      <CenterFill>
        <Button
          variant="ghost"
          onClick={nextStep}
        >
          Forgot Your Password?
        </Button>
      </CenterFill>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              handleCloseWizard();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            Log In
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default LoginForm;
